// extracted by css-extract-rspack-plugin
export default {"forgotPassword":"qcBjeDmUGoMLPreC"};